export function removeCountryCodeFormText(_text) {
  let text = _text;
  if (text && text.startsWith("88")) {
    text = text.slice(2);
  } else if (text && text.startsWith("+88")) {
    text = text.slice(3);
  }

  return text;
}

export function isPhoneNumber(_text) {
  if (!_text) {
    return false;
  }

  let text = removeCountryCodeFormText(_text);

  if (text.length !== 11) {
    return false;
  }

  let res = /^\d+$/.test(text);
  if (!res) {
    return false;
  }

  if (
    text.startsWith("010") ||
    text.startsWith("011") ||
    text.startsWith("012")
  ) {
    return false;
  }

  return text.startsWith("01");
}

export function formatPhoneNumber(phone) {
  if (!isPhoneNumber(phone)) {
    return undefined;
  } else if (phone.length === 11) {
    return `88${phone}`;
  } else if (phone.length === 13) {
    return phone;
  } else if (phone.length === 14) {
    return phone.slice(1);
  }
}
